/**
 * Created by viclight on 03.03.2024.
 */

import PageComponent from 'components/Page';
import ChangePasswordDialog from "./components/ChangePasswordDialog";


import './index.less';
import './themes/default.less';

import TabsSwitch from "../../components/TabsSwitch";

import React from "react";
import { HeaderEmployee } from "./components/headerEmployee";
import EmployeeData from "./components/employeeData";
import MotivationData from "./components/motivationData";
import PermissionsData from "./components/permissionsData";
import RecoveryPasswordDialog from "./components/RecoveryPasswordDialog";

import EditInfoDataPopup from "./components/editEmployeeInfoPopup";
import EditProfileDataPopup from "./components/editEmployeeProfilePopup";
import AvatarUploadDialog from "../../components/AvatarUploadDialog";

export default class Employee extends PageComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            info: false,

        };

        this.pages = {};
        this.setPageTitle();

    }

    get dialogsMap() {
        return {
            "changePassword": ChangePasswordDialog,
            "recoveryPassword": RecoveryPasswordDialog,
            "avatarUpload": AvatarUploadDialog,
        };
    }

    get rightPopupsMap() {
        return {
            "editInfoData": EditInfoDataPopup,
            "editProfileData": EditProfileDataPopup
        };
    }


    componentDidLoad() {
        const { tab } = this.state.urlProps;
        const cb = !tab ? null : this.changeTab.bind(this, tab);

        this.refresh(cb);
    }

    async refresh(cb) {
        this._helper.showLoading();

        const { id } = this.state.urlProps;

        const data = await this._request.employees.getEmployeeById(Number(id));

        if (data) {

            this.setPageTitle(this._helper.string.formatFullName(data));
            this.changeState("info", data, cb?.apply ? cb : null);

        }

        this._helper.hideLoading();

        this.refreshTab();
    }

    getDoctorById(id) {
        const doctor = this.state.doctors.find(it => it.id === id);
        return doctor?.domainId ? doctor : {};
    }

    refreshTab() {
        const currPage = this.pages[this.tabsView?.tabKey];

        if (currPage?.refresh?.apply)
            currPage.refresh();
    }

    async updateProfile(info) {
        this._helper.showLoading();
        const resp = await this._request.employees.update(this.state.info?.id, info);
        this._helper.hideLoading();

        if (resp?.data)
            this.refresh();
    }


    onChangePassword() {

    }


    onRecoveryPassword() {

    }

    renderHeaderEmployee(info) {

        return (
            <HeaderEmployee
                info={{ ...info }}
                openDialog={this.openDialog.bind(this)}
                changePasswordCB={this.onChangePassword.bind(this)}
                recoveryPasswordCB={this.onRecoveryPassword.bind(this)}
            />
        );
    }

    changeTab(tab, props) {
        this.changeTabProps = props;

        this.tabsView.setTab(tab);
    }

    onTabsChange(tab) {
        if (this._helper.getPageTab() === tab)
            return;

        const props = this.changeTabProps || {};
        this.setPageTab(tab, props);

        delete this.changeTabProps;
    }

    setPageTab(tab, props) {
        const { id } = this.state.urlProps;
        const p = props || {};

        this._helper.setPageTab(tab || this.tabsView.tabKey, { id, ...p });
    }

    renderTabsEmployee(info) {
        const props = {

            clinicId: this.state.clinicId,
            info,
            clinics: this.state.clinics,
            getDoctorById: this.getDoctorById.bind(this),
            openRightPopup: this.openRightPopup.bind(this),
            openDialog: this.openDialog.bind(this),
            updateProfile: this.updateProfile.bind(this),
            changeTab: this.changeTab.bind(this),
            refresh: this.refresh.bind(this),
            setPageTab: this.setPageTab.bind(this),
        };

        this.pages = {};

        return (
            <TabsSwitch
                ref={el => this.tabsView = el}
                className="flex1 minH0"
                links={["generalEmp", "motivation", "permissions"]}
                tabs={["employee.general", "employee.motivation", "employee.permissions"]}
                pages={[
                    <EmployeeData ref={el => this.pages["generalEmp"] = el} name="generalEmp" {...props} />,
                    <MotivationData ref={el => this.pages["motivation"] = el} name="flex col gap16" {...props} />,
                    <PermissionsData ref={el => this.pages["permissions"] = el} name="permissions" {...props} />,
                ]}
                onBeforeChange={this.onTabsChange.bind(this)}
            />
        );
    }

    renderPage() {
        const { info } = this.state;

        if (!info)
            return <></>;

        return (
            <div className="flex1 flex col container gap32">
                {this.renderHeaderEmployee(info)}
                {this.renderTabsEmployee(info)}
            </div>
        );
    }

}
